import { ReactComponent as AddImage } from './icons/add_image.svg';
import { ReactComponent as AiGenerate } from './icons/ai-generate.svg';
import { ReactComponent as ArrowDownBottomLine } from './icons/arrow-down-bottomline.svg';
import { ReactComponent as ArrowBack } from './icons/arrow-left.svg';
import { ReactComponent as ArrowLeftDS } from './icons/arrow-left-ds.svg';
import { ReactComponent as ArrowLeft } from './icons/arrow-narrow-left.svg';
import { ReactComponent as ArrowUpRight } from './icons/arrow-up-right.svg';
import { ReactComponent as Avatar } from './icons/avatar.svg';
import { ReactComponent as Bookmark } from './icons/bookmark.svg';
import { ReactComponent as ArchiveBox } from './icons/box-archive.svg';
import { ReactComponent as Briefcase } from './icons/briefcase.svg';
import { ReactComponent as Buildings } from './icons/buildings.svg';
import { ReactComponent as Buildings3 } from './icons/buildings-3.svg';
import { ReactComponent as Calendar } from './icons/calendar.svg';
import { ReactComponent as ChartColumn } from './icons/chart-column.svg';
import { ReactComponent as ChartLine } from './icons/chart-line.svg';
import { ReactComponent as Check } from './icons/check.svg';
import { ReactComponent as CheckCircle } from './icons/check-circle-blue.svg';
import { ReactComponent as CheckCircleFilled } from './icons/check-circle-filled.svg';
import { ReactComponent as Chevron } from './icons/chevron.svg';
import { ReactComponent as ChevronDouble } from './icons/chevron-double.svg';
import { ReactComponent as ChevronDoubleOut } from './icons/chevron-double-out.svg';
import { ReactComponent as ClipboardList } from './icons/clipboard-list.svg';
import { ReactComponent as ClockCheck } from './icons/clock-check.svg';
import { ReactComponent as ClockExclamation } from './icons/clock-exclamation.svg';
import { ReactComponent as Clone } from './icons/clone.svg';
import { ReactComponent as Comment } from './icons/comment.svg';
import { ContextMenuIcons } from './icons/context-menu';
import { ReactComponent as RuIcon } from './icons/countries/ru.svg';
import { ReactComponent as Cross } from './icons/cross.svg';
import { ReactComponent as CrossCircleFilled } from './icons/cross-circle-filled.svg';
import { ReactComponent as Dot } from './icons/dot.svg';
import { ReactComponent as Dots } from './icons/dots.svg';
import { ReactComponent as DownloadButton } from './icons/download_button.svg';
import { ReactComponent as DrawSquare } from './icons/draw-square.svg';
import { ReactComponent as Exclamation } from './icons/exclamation-circle.svg';
import { ReactComponent as ExclamationCircleFilled } from './icons/exclamation-circle-filled.svg';
import { ReactComponent as ExclamationTriangleFilled } from './icons/exclamation-triangle-filled.svg';
import { ReactComponent as Eye } from './icons/eye.svg';
import { ReactComponent as EyeSlash } from './icons/eye-slash.svg';
import { ReactComponent as File } from './icons/file_unknown.svg';
import { ReactComponent as FileXlsx } from './icons/file_xls.svg';
import { ReactComponent as FileChartColumn } from './icons/file-chart-column.svg';
import { ReactComponent as FileCheck } from './icons/file-check.svg';
import { ReactComponent as Filter } from './icons/filter.svg';
import { ReactComponent as Flat } from './icons/flat.svg';
import { ReactComponent as FolderImage } from './icons/folder-image.svg';
import { ReactComponent as Forms } from './icons/forms.svg';
import { ReactComponent as Gear } from './icons/gear.svg';
import { ReactComponent as Heart } from './icons/heart.svg';
import { ReactComponent as Heat } from './icons/heat.svg';
import { ReactComponent as Home } from './icons/home.svg';
import { ReactComponent as IconRecord } from './icons/icon-record.svg';
import { ReactComponent as ImageSquare } from './icons/image-square.svg';
import { ReactComponent as InformationCircle } from './icons/information-circle.svg';
import { ReactComponent as InformationCircleFilled } from './icons/information-circle-filled.svg';
import { ReactComponent as Layers } from './icons/layers.svg';
import { ReactComponent as Lift } from './icons/lift.svg';
import { ReactComponent as LinkIcon } from './icons/link.svg';
import { ReactComponent as ListDot } from './icons/list-dot.svg';
import { ReactComponent as Loader } from './icons/loader.svg';
import { ReactComponent as LocationFill } from './icons/location-fill.svg';
import { ReactComponent as LocationPin } from './icons/location-pin.svg';
import { ReactComponent as OneCLogo } from './icons/logos/1c-logo.svg';
import { ReactComponent as AdsLogo } from './icons/logos/ads-logo.svg';
import { ReactComponent as ESIALogo } from './icons/logos/esia-logo.svg';
import { ReactComponent as Logo7300 } from './icons/logos/frc-logo.svg';
import { ReactComponent as MagicPencil } from './icons/magic-pencil.svg';
import { ReactComponent as MagicVoice } from './icons/magic-voice.svg';
import { ReactComponent as Mail } from './icons/mail.svg';
import { ReactComponent as MailLink } from './icons/mail_link.svg';
import { ReactComponent as Map } from './icons/map.svg';
import { ReactComponent as CirclePause } from './icons/media/circle-pause.svg';
import { ReactComponent as CirclePlay } from './icons/media/circle-play.svg';
import { ReactComponent as VolumeMedium } from './icons/media/volume-medium.svg';
import { ReactComponent as Menu } from './icons/menu.svg';
import { ReactComponent as MessageCircle } from './icons/message-circle.svg';
import { ReactComponent as MessageCircleDots } from './icons/message-circle-dots.svg';
import { ReactComponent as MessageCircleLines } from './icons/message-circle-lines.svg';
import { ReactComponent as MessageSquareLines } from './icons/message-square-lines.svg';
import { ReactComponent as MessageRead } from './icons/messenger/message-read.svg';
import { ReactComponent as MessageUnread } from './icons/messenger/message-unread.svg';
import { ReactComponent as ColdWaterMeter } from './icons/meters-new/cold-water.svg';
import { ReactComponent as ElectricityMeter } from './icons/meters-new/electricity.svg';
import { ReactComponent as GasMeter } from './icons/meters-new/gas.svg';
import { ReactComponent as HeatMeter } from './icons/meters-new/heat.svg';
import { ReactComponent as HotWaterMeter } from './icons/meters-new/hot-water.svg';
import { ReactComponent as Minus } from './icons/minus.svg';
import { ReactComponent as MinusCircle } from './icons/minus-circle.svg';
import { ReactComponent as Money } from './icons/money.svg';
import { ReactComponent as Music } from './icons/music.svg';
import { ReactComponent as NextIcon } from './icons/next_icon.svg';
import { ReactComponent as PaperAirplane } from './icons/paper-airplane.svg';
import { ReactComponent as Paperclip } from './icons/paperclip.svg';
import { ReactComponent as Pause } from './icons/pause.svg';
import { ReactComponent as PenHollow } from './icons/pen_hollow.svg';
import { ReactComponent as Pen } from './icons/pen-icon.svg';
import { ReactComponent as PenLine } from './icons/pen-line.svg';
import { ReactComponent as Phone } from './icons/phone.svg';
import { ReactComponent as CallEnd } from './icons/call-end.svg';
import { ReactComponent as Play } from './icons/play.svg';
import { ReactComponent as Plus } from './icons/plus.svg';
import { ReactComponent as QuestionCircle } from './icons/question-circle-big.svg';
import { ReactComponent as RatingDown } from './icons/rating/rating_down.svg';
import { ReactComponent as RatingUp } from './icons/rating/rating_up.svg';
import { ReactComponent as Refresh } from './icons/refresh.svg';
import { ReactComponent as Search } from './icons/search.svg';
import { ReactComponent as SelectorVertical } from './icons/selector-vertical.svg';
import { ReactComponent as Share } from './icons/share.svg';
import { ReactComponent as SimCard } from './icons/sim-card.svg';
import { ReactComponent as MaxLogo } from './icons/social/max.svg';
import { ReactComponent as OKLogo } from './icons/social/ok.svg';
import { ReactComponent as TelegramSquaredLogo } from './icons/social/telegram-squared.svg';
import { ReactComponent as VKLogo } from './icons/social/vk.svg';
import { ReactComponent as WhatsappLogo } from './icons/social/whatsapp.svg';
import { ReactComponent as Star } from './icons/star.svg';
import { ReactComponent as TeamMember } from './icons/team_member.svg';
import { ReactComponent as TelegramLogo } from './icons/telegram.svg';
import { ReactComponent as Temperature } from './icons/temperature-plus.svg';
import { ReactComponent as ThumbsUp } from './icons/thumbs-up.svg';
import { ReactComponent as Timer } from './icons/timer.svg';
import { ReactComponent as TowerBroadcast } from './icons/tower-broadcast.svg';
import { ReactComponent as Trash } from './icons/trash.svg';
import { ReactComponent as Truck } from './icons/truck.svg';
import { ReactComponent as User } from './icons/user.svg';
import { ReactComponent as UserQuestion } from './icons/user-question.svg';
import { ReactComponent as Users } from './icons/users.svg';
import { ReactComponent as Wallet } from './icons/wallet.svg';
import { ReactComponent as CrossCircle } from './icons/x-circle.svg';

const Countries = {
  RU: RuIcon,
};

const Meters = {
  ColdWaterMeter,
  ElectricityMeter,
  GasMeter,
  HeatMeter,
  HotWaterMeter,
};

const Logos = {
  '7300': Logo7300,
  ADS: AdsLogo,
  OneC: OneCLogo,
  ESIA: ESIALogo,
  Telegram: TelegramLogo,
  VK: VKLogo,
  Whatsapp: WhatsappLogo,
  MaxLogo,
  OKLogo,
  TelegramSquaredLogo,
};

export const Icons = {
  ...Countries,
  ...ContextMenuIcons,
  ...Logos,
  ...Meters,
  Avatar,
  Bookmark,
  Check,
  CheckCircle,
  MinusCircle,
  User,
  Users,
  UserQuestion,
  Flat,
  ArrowLeft,
  ArrowLeftDS,
  MessageCircle,
  Filter,
  Trash,
  Star,
  Pen,
  PenLine,
  Chevron,
  ChevronDouble,
  ChevronDoubleOut,
  Cross,
  CrossCircle,
  MailLink,
  Phone,
  CallEnd,
  RatingUp,
  RatingDown,
  Calendar,
  Timer,
  Search,
  Exclamation,
  Dots,
  Clone,
  TeamMember,
  Plus,
  Refresh,
  Paperclip,
  Loader,
  Briefcase,
  Dot,
  ArrowBack,
  ArchiveBox,
  MessageRead,
  MessageUnread,
  NextIcon,
  LinkIcon,
  Home,
  PenHollow,
  Mail,
  DownloadButton,
  ArrowDownBottomLine,
  PaperAirplane,
  Heat,
  MessageCircleDots,
  MessageCircleLines,
  MessageSquareLines,
  QuestionCircle,
  ArrowUpRight,
  Gear,
  Heart,
  ClockExclamation,
  ClockCheck,
  Minus,
  DrawSquare,
  Layers,
  FileChartColumn,
  FileCheck,
  SimCard,
  FileXlsx,
  Temperature,
  File,
  ClipboardList,
  ChartColumn,
  Buildings,
  Buildings3,
  AddImage,
  ChartLine,
  Forms,
  ThumbsUp,
  CirclePlay,
  CirclePause,
  VolumeMedium,
  IconRecord,
  InformationCircleFilled,
  ExclamationCircleFilled,
  ExclamationTriangleFilled,
  Play,
  Pause,
  Menu,
  ListDot,
  Map,
  LocationPin,
  LocationFill,
  Truck,
  CheckCircleFilled,
  CrossCircleFilled,
  InformationCircle,
  Money,
  Music,
  Share,
  Wallet,
  SelectorVertical,
  Comment,
  ImageSquare,
  TowerBroadcast,
  AiGenerate,
  Eye,
  EyeSlash,
  Lift,
  FolderImage,
  MagicPencil,
  MagicVoice,
};
